import { isWebview } from '../../node_modules/@zillow/mortgage-webview-query-params/dist/mortgage-webview-query-params.esm.js';
import { buildUrlQueryParams } from './api.js';
import { getConfigs } from './configs.js';

var getDownPaymentAssistanceUrl = function getDownPaymentAssistanceUrl() {
  var _getConfigs = getConfigs(),
    zillowBaseUrl = _getConfigs.zillowBaseUrl;
  return "".concat(zillowBaseUrl, "/down-payment-assistance?source=Z_HomeLoans_Landing&utm_source=zillow&utm_medium=referral&utm_campaign=zhl_homeloanslp_calculator_component_main");
};

// only available in prod
var getCreditScoreArticleUrl = function getCreditScoreArticleUrl() {
  return 'https://www.zillow.com/mortgage-learning/credit-score-higher/?source=Z_HomeLoans_Landing&utm_source=zillow&utm_medium=referral&utm_campaign=zhl_homeloanslp_calculator_component_main';
};
var getPayOffDebtsGuideUrl = function getPayOffDebtsGuideUrl() {
  return 'https://www.zillow.com/home-buying-guide/pay-off-debt/?source=Z_HomeLoans_Landing&utm_source=zillow&utm_medium=referral&utm_campaign=zhl_homeloanslp_calculator_component_main';
};
var getZGMICustomQuoteUrl = function getZGMICustomQuoteUrl(outputs) {
  var _outputs$inputFields, _outputs$inputFields2, _outputs$inputFields3;
  var _getConfigs2 = getConfigs(),
    zillowBaseUrl = _getConfigs2.zillowBaseUrl;
  var underWebview = isWebview();
  var path = underWebview ? '/mortgage/webviews/ZCQ.htm' : '/mortgage-rates/';
  var query = {
    source: 'Z_HomeLoans_Landing',
    utm_source: 'zillow',
    utm_medium: 'referral',
    utm_campaign: 'zhl_homeloanslp_calculator_component_main',
    loanType: 'purchase',
    propertyValue: Math.floor(outputs === null || outputs === void 0 ? void 0 : outputs.homePrice),
    location: outputs === null || outputs === void 0 ? void 0 : (_outputs$inputFields = outputs.inputFields) === null || _outputs$inputFields === void 0 ? void 0 : _outputs$inputFields.zipCode,
    creditScore: outputs === null || outputs === void 0 ? void 0 : (_outputs$inputFields2 = outputs.inputFields) === null || _outputs$inputFields2 === void 0 ? void 0 : _outputs$inputFields2.creditScore,
    downPayment: Math.floor(outputs === null || outputs === void 0 ? void 0 : (_outputs$inputFields3 = outputs.inputFields) === null || _outputs$inputFields3 === void 0 ? void 0 : _outputs$inputFields3.downPayment)
  };
  if (underWebview) {
    query.zfullscreen = true;
  }
  return "".concat(zillowBaseUrl).concat(path, "?").concat(buildUrlQueryParams(query));
};
var getPrequalUrl = function getPrequalUrl(outputs) {
  var _outputs$inputFields4, _outputs$inputFields5, _outputs$inputFields6;
  var _getConfigs3 = getConfigs(),
    zhlBaseUrl = _getConfigs3.zhlBaseUrl;
  var underWebview = isWebview();
  var query = {
    source: 'Zillow',
    channel: 'Home_Loans',
    utm_source: 'zillow',
    utm_medium: 'referral',
    utm_campaign: 'zhl_homeloanslp_calculator_component_main',
    propertyValue: Math.floor(outputs === null || outputs === void 0 ? void 0 : outputs.homePrice),
    cityOrZip: outputs === null || outputs === void 0 ? void 0 : (_outputs$inputFields4 = outputs.inputFields) === null || _outputs$inputFields4 === void 0 ? void 0 : _outputs$inputFields4.cityOrZip,
    creditScore: outputs === null || outputs === void 0 ? void 0 : (_outputs$inputFields5 = outputs.inputFields) === null || _outputs$inputFields5 === void 0 ? void 0 : _outputs$inputFields5.creditScore,
    downPayment: Math.floor(outputs === null || outputs === void 0 ? void 0 : (_outputs$inputFields6 = outputs.inputFields) === null || _outputs$inputFields6 === void 0 ? void 0 : _outputs$inputFields6.downPayment)
  };
  if (underWebview) {
    query.zfullscreen = true;
  }
  return "".concat(zhlBaseUrl, "/pre-qualify/?").concat(buildUrlQueryParams(query));
};
var getFindHomeUrl = function getFindHomeUrl() {
  var _getConfigs4 = getConfigs(),
    zillowBaseUrl = _getConfigs4.zillowBaseUrl;
  var query = {
    source: 'Z_HomeLoans_Landing',
    channel: 'Home_Loans',
    utm_source: 'zillow',
    utm_medium: 'referral',
    utm_campaign: 'zhl_homeloanslp_calculator_component_secondary'
  };
  return "".concat(zillowBaseUrl, "/homes/?").concat(buildUrlQueryParams(query));
};

export { getCreditScoreArticleUrl, getDownPaymentAssistanceUrl, getFindHomeUrl, getPayOffDebtsGuideUrl, getPrequalUrl, getZGMICustomQuoteUrl };
//# sourceMappingURL=url.js.map
